module.exports = __webpack_public_path__ + "img/conny-f-stage6.8c53b4e3.png";